<template>
  <div class="pb-10">
    <div v-if="!loading">
      <div v-if="dataSet.length">
        <draggable
          v-model="dataSet"
          class="list-group"
          @start.prevent="drag = true"
          @end="draged"
          v-bind="dragOptions"
          handle=".handle"
        >
          <transition-group
            type="transition"
            :name="!drag ? 'flip-list' : null"
          >
            <div class="mb-4" v-for="(item, i) in dataSet" :key="`sect_${i}`">
              <v-card
                class="rounded_max d-flex"
                elevation="1"
                style="overflow: hidden"
                @click.prevent="toDetail(item)"
              >
                <div
                  class="strip"
                  :style="`background: ${color ? color : '#f0ac91'}`"
                ></div>
                <v-row no-gutters>
                  <v-col cols="8" md="10" lg="10">
                    <div class="pa-3 d-flex align-center">
                      <v-btn
                        fab
                        :color="color ? color : '#f0ac91'"
                        dark
                        class="mr-2"
                        depressed
                        small
                      >
                        <v-icon> {{ item.icon }}</v-icon>
                      </v-btn>
                      <div>
                        <div class="d-flex align-center gap-3">
                          <b> {{ item.title }} </b>
                          <p
                            class="text-caption ma-0 default_txt ml-3"
                            v-if="item.copying"
                          >
                            Copying...
                          </p>
                        </div>
                        <p class="default_txt ma-0">
                          {{ item.data_module.description }}
                        </p>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" md="2" lg="2"
                    ><div
                      class="pa-3 d-flex align-center justify-end handle"
                      style="height: 100%"
                      v-if="!permissions.includes('GUEST')"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-menu offset-y nudge-bottom="5px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="blue"
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                >
                                  <v-icon>mdi-content-copy </v-icon>
                                </v-btn>
                              </template>
                              <v-card min-width="200px" flat>
                                <v-list dense>
                                  <v-list-item-group
                                    v-model="selectedType"
                                    color="primary"
                                  >
                                    <v-list-item
                                      v-for="(type, i) in typeList"
                                      :key="i"
                                      @click="selectCopy(type, item)"
                                    >
                                      <v-list-item-content>
                                        <v-list-item-title
                                          v-text="type.text"
                                        ></v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-card>
                            </v-menu>
                          </div>
                        </template>
                        <span>Copy Module</span>
                      </v-tooltip>

                      <v-btn icon class="handle" style="cursor: move">
                        <v-icon>mdi-drag </v-icon>
                      </v-btn>
                    </div></v-col
                  >
                </v-row>
              </v-card>
            </div>
          </transition-group>
        </draggable>
      </div>
      <div
        v-if="!dataSet.length"
        class="d-flex align-center justify-center flex-column"
      >
        <img
          src="../../../../assets/img/gundam/LMS Aset Illustrasi No Modules.png"
          height="200px"
          alt=""
        />
        <b class="default_txt my-3">This is where you add the module</b>
        <p class="default_txt ma-0">
          You can add some type of module according to what you need
        </p>
      </div>
    </div>
    <div v-if="loading" class="_temp_list">
      <v-row no-gutters>
        <v-col cols="12" v-for="i in 3" :key="i">
          <div class="py-3">
            <v-skeleton-loader
              type="image"
              class="rounded_max"
              height="80px"
            ></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-snackbar v-model="sorting" left :timeout="'-1'">
      {{ msg }}
    </v-snackbar>
    <CopyModule
      :dialog="d_copy"
      @close="d_copy = false"
      @refetch="onSuccessCopy"
      :inventory="inventory"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";
import CopyModule from "./copyModule.vue";
export default {
  name: "listModule",
  props: ["color", "section"],
  components: { draggable, CopyModule },
  mounted() {
    this.fetchData();
  },
  // =>
  data() {
    return {
      loading: true,
      dataSet: null,
      drag: false,
      sorted: [],
      sorting: false,
      msg: "",
      icon: [
        {
          id: 1,
          mdi: "mdi-order-bool-ascending-variant",
        },
        {
          id: 2,
          mdi: "mdi-clipboard-check",
        },

        {
          id: 3,
          mdi: "mdi-book-check",
        },
        {
          id: 4,
          mdi: "mdi-text-box-check",
        },
        {
          id: 5,
          mdi: "mdi-notebook-check",
        },
        {
          id: 6,
          mdi: "mdi-book-sync-outline",
        },
        {
          id: 7,
          mdi: "mdi-puzzle-check",
        },

        {
          id: 8,
          mdi: "mdi-account-check-outline",
        },
      ],
      selectedType: null,
      typeList: [
        {
          text: "Copy to this section",
          value: "this",
        },
        {
          text: "Copy to other section",
          value: "other",
        },
        {
          text: "Copy to other course section",
          value: "other-course",
        },
      ],
      d_copy: false,
      inventory: null,
      course: null,
    };
  },
  //   =>
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
    }),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/course/section/module/${this.$route.params.idSection}?include=dataModule`,
      };
      this.$store.dispatch("course/getData", data).then((data) => {
        this.loading = false;
        this.dataSet = data.data;
        this.dataSet.forEach((el) => {
          console.log(el);

          el["copying"] = false;
          this.icon.forEach((ico) => {
            if (el.module_id == ico.id) {
              el["icon"] = ico.mdi;
            }
          });
        });
      });
    },
    toDetail(item) {
      let section = item.course_section_id;
      let course = this.$route.params.idCourse;
      this.$router.push(
        `/module/inclass/${section}/${course}/${item.module_id}/${item.instance_id}/${item.data_module.title}/config`,
      );
    },
    draged() {
      this.drag = false;
      this.dataSet.forEach((el, idx) => {
        let obj = {
          id: el.id,
          weight: idx + 1,
        };
        this.sorted.push(obj);
      });
      this.switchOrder();
    },

    switchOrder() {
      this.msg = "moving module...";
      this.sorting = true;
      let body = {
        course_section_id: this.$route.params.idSection,
        data_course: this.sorted,
      };
      let data = {
        path: `manage/course/section/module/weight/switch`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then(() => {
          this.msg = "Module moved";
          setTimeout(() => {
            this.sorting = false;
          }, 800);
        })
        .catch((err) => {
          this.msg = "Error";
          setTimeout(() => {
            this.sorting = false;
          }, 800);
        });
    },

    selectCopy(type, item) {
      item["type"] = type.value;
      item["course_id"] = this.$route.params.idCourse;
      console.log(item);
      if (type.value == "this") {
        this.onCopy(item);
      } else {
        this.inventory = item;
        this.d_copy = true;
      }
    },

    onCopy(item) {
      item.copying = true;
      let body = {
        module_id: item.module_id,
        instance_id: item.instance_id,
        course_section_id: this.$route.params.idSection,
        new_course_section_id: this.$route.params.idSection,
      };
      let data = {
        path: `copy/module`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((res) => {
          item.copying = false;
          res["data_module"] = item.data_module;
          console.log(res);

          this.toDetail(res);
          this.fetchData();
        })
        .catch((err) => {
          console.log(err);

          item.copying = false;
        });
    },
    onSuccessCopy(item) {
      this.toDetail(item);
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
</style>
